class Logger {
  log(...message: any[]) {
    if (process.env.APPLICATION_ENV === 'development') {
      console.log(
        '[Wizard][Logger]',
        message.map((m) => JSON.stringify(m, null, 2)).join(' ')
      );
    }
  }
}

export default new Logger();
